import {
  BASE_URL,
  CREATE_TRANSACTION,
  CREATE_MASTER_TRANSACTION,
} from "../config";
import { getSessionId } from "../utils/SessionHandler";
import { handleResponse } from "./responseHandler";

export async function createTransaction(fieldData) {
  const response = await fetch(BASE_URL + CREATE_TRANSACTION, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(fieldData),
  });
  return handleResponse(response);
}

export async function fetchTransactions(query) {
  const response = await fetch(
    BASE_URL + "api/v1/organisation/admin/transaction" + query,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getSessionId()}`,
      },
    }
  );
  return handleResponse(response);
}

export async function updateTransaction(id, transactionData) {
  const response = await fetch(
    `${BASE_URL}api/v1/organisation/admin/transaction/update/${id}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getSessionId()}`,
      },
      body: JSON.stringify(transactionData),
    }
  );
  return handleResponse(response);
}

export async function createMasterTransaction(fieldData) {
  const response = await fetch(BASE_URL + CREATE_MASTER_TRANSACTION, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getSessionId()}`,
    },
    body: JSON.stringify(fieldData),
  });
  return handleResponse(response);
}
